import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconBrushSize = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 3.55,
			d: "M1.764 9.734C7.37 3.488 9.69 7.455 9.69 7.455c3.394 4.224 4.951 3.528 8.548 1.808 2.667-1.705 2.678-1.721 3.997-3.158"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.9,
			d: "M1.764 15.178C7.37 8.932 9.69 12.9 9.69 12.9c3.394 4.224 4.951 3.528 8.548 1.808 2.667-1.705 2.678-1.722 3.997-3.159"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M1.764 19.34c5.607-6.246 7.928-2.278 7.928-2.278 3.393 4.224 4.95 3.527 8.547 1.807 2.667-1.704 2.678-1.721 3.997-3.158"
		})
	]
});
export default SvgIconBrushSize;
